import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { getVisibleSlides, getCustomWidths } from './helpers';
import { ScrollFlex } from './styles';
import { Slide } from './Slide';
var propTypes = {
    children: PropTypes.node,
    visibleSlides: PropTypes.any,
    onSlideChange: PropTypes.func,
    slideSpacing: PropTypes.number,
    stretchHeight: PropTypes.bool,
    layout: PropTypes.string,
    currentSlideOverride: PropTypes.number,
};
var SlideBox = function (_a) {
    var children = _a.children, visibleSlides = _a.visibleSlides, onSlideChange = _a.onSlideChange, slideSpacing = _a.slideSpacing, stretchHeight = _a.stretchHeight, layout = _a.layout, currentSlideOverride = _a.currentSlideOverride;
    var _b = useState(), currentSlide = _b[0], setCurrentSlide = _b[1];
    var ref = useRef();
    useEffect(function () {
        setCurrentSlide(currentSlideOverride);
    }, [currentSlideOverride]);
    return (React.createElement(ScrollFlex, { width: '100%', py: 2, "data-testid": 'slide-box', ref: ref }, React.Children.toArray(children).map(function (item, index) { return (React.createElement(Slide, { key: item.props.key || "slide".concat(index), width: layout ? getCustomWidths(layout.split('-'), index) : getVisibleSlides(visibleSlides), onSlideChange: onSlideChange, slideSpacing: slideSpacing, stretchHeight: stretchHeight, index: index, content: item, isCurrentSlide: currentSlide === index, numSlides: children.length, slideBoxRef: ref })); })));
};
export { SlideBox };
//# sourceMappingURL=SlideBox.js.map